import React, { useState } from "react";
import apiClient from "../../utils/apiclient";

const Index = () => {
  const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;
  const [Userid, setUserId] = useState("");
  const [Mealid, setMealId] = useState("");

  const [lunchstarttime, setLunchStartTime] = useState("");
  const [lunchendtime, setLunchEndTime] = useState("");

  const [dinnerstarttime, setDinnerStartTime] = useState("");
  const [dinnerendtime, setDinnerEndTime] = useState("");

  const [couponId, setCouponId] = useState("");
  const [useBBCurrency, setUseBBCurrency] = useState(false);
  const [onlinePayment, setOnlinePayment] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      lunchstarttime: lunchstarttime || null,
      lunchendtime: lunchendtime || null,
      dinnerstarttime: dinnerstarttime || null,
      dinnerendtime: dinnerendtime || null,
      couponId: couponId || null,
      useBBCurrency,
      onlinePayment,
    };

    console.log("Subscription Payload:", payload);

    try {
      const response = await apiClient.post(
        `/create/subscription/${Userid}/${Mealid}`,
        payload
      );

      console.log(response.data);
      alert("Subscription created successfully");
    } catch (e) {
      console.error(e.response?.data || e.message);
      alert("Error creating subscription");
    }
  };

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4 overflow-auto px-2 md:px-4">
      {isAdmin && (
        <form onSubmit={handleSubmit} className="w-full max-w-4xl bg-white border border-gray-300 shadow-sm">
          <div className="bg-gray-800 text-white px-4 py-2 sticky top-0 z-10 shadow-md">
            <h2 className="text-sm md:text-base font-bold">Create Subscription</h2>
          </div>

          <div className="p-3 md:p-5 flex flex-col gap-4">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex flex-col md:flex-row gap-2 md:items-center flex-1">
                <label className="text-[10px] md:text-sm font-semibold w-24 flex-shrink-0 text-gray-700">User ID</label>
                <input
                  className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                  type="text"
                  placeholder="User ID"
                  value={Userid}
                  onChange={(e) => setUserId(e.target.value)}
                  required
                />
              </div>
              <div className="flex flex-col md:flex-row gap-2 md:items-center flex-1">
                <label className="text-[10px] md:text-sm font-semibold md:w-20 flex-shrink-0 text-gray-700">Meal ID</label>
                <input
                  className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                  type="text"
                  placeholder="Meal ID"
                  value={Mealid}
                  onChange={(e) => setMealId(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="border border-gray-300 mt-2">
              <div className="bg-gray-100 px-3 py-2 border-b border-gray-300">
                <h3 className="text-[10px] md:text-sm font-bold text-gray-700">Lunch Time</h3>
              </div>
              <div className="p-3 flex flex-col md:flex-row gap-4 bg-gray-50">
                <div className="flex flex-1 flex-col md:flex-row gap-2 md:items-center">
                  <label className="text-[10px] md:text-sm font-semibold w-16 flex-shrink-0 text-gray-700">Start</label>
                  <input
                    className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                    type="time"
                    value={lunchstarttime}
                    onChange={(e) => setLunchStartTime(e.target.value)}
                  />
                </div>
                <div className="flex flex-1 flex-col md:flex-row gap-2 md:items-center">
                  <label className="text-[10px] md:text-sm font-semibold md:w-16 flex-shrink-0 text-gray-700">End</label>
                  <input
                    className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                    type="time"
                    value={lunchendtime}
                    onChange={(e) => setLunchEndTime(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="border border-gray-300 mt-2">
              <div className="bg-gray-100 px-3 py-2 border-b border-gray-300">
                <h3 className="text-[10px] md:text-sm font-bold text-gray-700">Dinner Time</h3>
              </div>
              <div className="p-3 flex flex-col md:flex-row gap-4 bg-gray-50">
                <div className="flex flex-1 flex-col md:flex-row gap-2 md:items-center">
                  <label className="text-[10px] md:text-sm font-semibold w-16 flex-shrink-0 text-gray-700">Start</label>
                  <input
                    className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                    type="time"
                    value={dinnerstarttime}
                    onChange={(e) => setDinnerStartTime(e.target.value)}
                  />
                </div>
                <div className="flex flex-1 flex-col md:flex-row gap-2 md:items-center">
                  <label className="text-[10px] md:text-sm font-semibold md:w-16 flex-shrink-0 text-gray-700">End</label>
                  <input
                    className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                    type="time"
                    value={dinnerendtime}
                    onChange={(e) => setDinnerEndTime(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4 mt-2">
              <label className="flex items-center gap-2 text-[10px] md:text-sm text-gray-700 cursor-pointer">
                <input
                  type="checkbox"
                  className="w-3 h-3 md:w-4 md:h-4 cursor-pointer"
                  checked={useBBCurrency}
                  onChange={(e) => setUseBBCurrency(e.target.checked)}
                />
                Use BB Currency
              </label>
              <label className="flex items-center gap-2 text-[10px] md:text-sm text-gray-700 cursor-pointer">
                <input
                  type="checkbox"
                  className="w-3 h-3 md:w-4 md:h-4 cursor-pointer"
                  checked={onlinePayment}
                  onChange={(e) => setOnlinePayment(e.target.checked)}
                />
                Online Payment
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-2 md:items-center mt-2">
              <label className="text-[10px] md:text-sm font-semibold w-24 flex-shrink-0 text-gray-700">Coupon ID</label>
              <input
                className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                type="text"
                placeholder="Optional Coupon ID"
                value={couponId}
                onChange={(e) => setCouponId(e.target.value)}
              />
            </div>

            <div className="mt-4 flex justify-end">
              <button
                type="submit"
                className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded transition"
              >
                Submit Subscription
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default Index;
